import { Component, Input, OnInit, inject } from '@angular/core';
import { InstituicaoEnsinoService } from '../../api/services/instituicao-ensino.service';
import { CommonModule } from '@angular/common';
import { ApiService } from '@core/providers/http';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-listar-instituicoes-ensino',
  templateUrl: './listar-instituicoes-ensino.component.html',
  styleUrls: ['./listar-instituicoes-ensino.component.scss'],
  standalone: true,
  providers: [InstituicaoEnsinoService, ApiService, ConfirmationService],
  imports: [
    CommonModule,
    TableModule,
    DropdownModule,
    ToastModule,
    ConfirmDialogModule,
    SearchBarComponent,
  ],
})
export class ListarInstituicoesEnsinoComponent implements OnInit {
  @Input() bolsaID!: string;
  instituicoes: any[] = [];
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  actionOptions = [
    { label: 'Editar', value: 'edit' },
    { label: 'Eliminar', value: 'delete' },
  ];
  ngOnInit(): void {
    this.loadInstituicoesByBolsaID();
  }

  loadInstituicoesByBolsaID() {
    this.instituicaoEnsinoService.list({ BolsaID: this.bolsaID }).subscribe(
      (instituicoes) => {
        this.instituicoes = instituicoes;
      },
      (error) => {
        console.error('Erro ao carregar instituições de ensino:', error);
      }
    );
  }

  showDialog() {
    // Lógica para mostrar um modal
  }

  // Você pode adicionar funções para as ações do dropdown, se necessário
  actionSelected(event: any, instituicao: any) {
    // Lógica para executar uma ação com base na seleção do dropdown
    console.log('Ação selecionada:', event, instituicao);
  }
}
